<template>
    <div>
        <Header/>
            <router-view></router-view>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    export default {
        name: 'AppLayout',
        components: {
            Header
        },
        data () {
            return {
            //
            }
        }
    }
</script>

<style>
    #app-home {
        background: #151110 url("/img/main-background.jpg") center top;
    }
</style>